import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { StyledBackground, StyledGradient } from './Background.styled';

const Background: React.FC = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Default} />
			)}
			<StyledBackground />
			<StyledGradient />
		</Fragment>
	);
};

export { Background };
